import Swiper, { Navigation, Pagination } from 'swiper'

const SwiperProcess = function () {
  Swiper.use(Navigation, Pagination);

  const processContainer = document.querySelector('.process-swiper-container');
  if (processContainer) {
    const processSwiper = new Swiper( '.process-swiper', {
      direction: 'horizontal',
      slidesPerView: 1,
      slidesPerGroup: 1,
      spaceBetween: 50,
      centeredSlides: true,
      initialSlide: 0,
      loop: true,
      allowTouchMove: false,
      pagination: {
        el: document.querySelector('.swiper-pagination'),
        clickable: true
      },
      navigation: {
        nextEl: processContainer.querySelector('.swiper-button-next'),
        prevEl: processContainer.querySelector('.swiper-button-prev')
      },
      breakpoints: {
        992: {
          spaceBetween: 5,
          centeredSlides: false
        }
      }  
    })

    // Add Numbers to Pagination
    let processPagination = processContainer.querySelectorAll('.swiper-pagination-bullet');
    if (processContainer) {
      processPagination.forEach((bullet, i) => {
        bullet.insertAdjacentText('afterbegin', i + 1);
        i++;
      });
    }

    // Change images on thumbnail click
    let processSlide = processContainer.querySelectorAll('.swiper-slide');
    processSlide.forEach( (slide, i) => { 
      let imageThumb = slide.querySelectorAll('.thumbnail-block');
      imageThumb[0].querySelector('.image-wrap').classList.add('active');
      
      imageThumb.forEach(thumb => {
        let imageMain = slide.querySelector('.image-main');
        let thumbSrc = thumb.querySelector('img').getAttribute('src');
        thumb.addEventListener('click', function() {
          imageMain.querySelector('img').src = thumbSrc;
          $(this).closest('.thumbnails').find('.image-wrap').removeClass('active');
          $(this).find('.image-wrap').addClass('active');
        })
      });
      i++;
    });
  }
}

export default SwiperProcess;